import { Directive, Input, HostListener } from '@angular/core';
import { AppConfigService, ToastService } from '../services';
import * as Parse from 'parse';

@Directive({selector: '[copyToClipboard]'})
export class CopyToClipboardDirective {
    @Input('copyToClipboard') copyToClipboard: string = '';
    @Input() isFlyer: boolean = false;
    public propertyId: string = '';
    public apiUrl = this.appConfig.server.url.split('/api')[0];

    constructor(
        private appConfig: AppConfigService,
        private toast: ToastService
    ) {}

    @HostListener('click', ['$event'])
    public onClick(event: MouseEvent): void {
        event.preventDefault();
        event.stopPropagation();

        let listener;

        if (this.isFlyer) {
            listener = (e: ClipboardEvent) => {
                const clipboard = e.clipboardData;
                const url: string = window.location.origin + '/flyer/' + this.propertyId;
                (clipboard as DataTransfer).setData('text', url);
                e.preventDefault();

                void this.toast.showSuccess('Flyer Url has been placed in your clipboard.');
            };
        } else {
            listener = (e: ClipboardEvent) => {
                const clipboard = e.clipboardData;
                const url: string = this.apiUrl + '/share/' + Parse.User.current()?.get('userSlug') + '/' + this.propertyId;
                (clipboard as DataTransfer).setData('text', url);
                e.preventDefault();

                void this.toast.showSuccess('Property Url has been placed in your clipboard.');
            };
        }

        // safari bugfix
        // some text needs to be selected for document.execCommand() to work
        const textArea = document.createElement('textArea');
        (textArea as any).value = 'text to be copied';
        document.body.appendChild(textArea);
        (textArea as any).select();

        document.addEventListener('copy', listener);
        document.execCommand('copy');
        document.removeEventListener('copy', listener);
        document.body.removeChild(textArea);
    }
}
